import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IRequestProductionDetail } from '../../../interfaces/sp/productionbymachine';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root'
})
export class ProductionByMachineService {
  private baseUrl: string;
  constructor(private http: HttpClient, private urlBuilderService: UrlBuilderService) {
    this.baseUrl = `${this.urlBuilderService.apiUrl}/Production/`;
  }

  /**
   * Funciton get production detail by machine.
   */
  public async getProductionDetailByMachine(reqParams: IRequestProductionDetail): Promise<any> {
    const url = `${this.baseUrl}ProductionDetailByMachine`;

    let params = new HttpParams();
    Object.keys(reqParams).forEach(key => params = params.set(key, reqParams[key]));

    return this.http.get(url, {params}).toPromise();
  }
}
